// Link to thread discussing why uuid4 is implemented like this: https://gist.github.com/jed/982883/55ddc95d05a23a18d428452c2efe21a895ae531a

export function uuidv4(): string {
  return '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, (c: any) =>
    (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
  )
}
